import React, {useState} from "react";

import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import {useMediaQuery} from "react-responsive";
import {Tag} from "primereact/tag";


function DashBoardPanel({
                            inputList,
                            kitUsed,
                            outputList,
                            processData,
                            locationList,
                            mfxList,
                            expList
                        }) {
    const isDesktop = useMediaQuery({query: '(min-width: 800px)'})
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [inputLists, setInputLists] = useState(inputList)
    const [defectLists, setDefectLists] = useState([{id: 0, name: "", quantity: 0}]);
    const [selectedInput, setSelectedInput] = useState({id: 0, name: 0, quantity: 0})
    const [selectedDefects, setSelectedDefects] = useState(null)
    const [selectedMfxs, setSelectedMfxs] = useState({id: 0, name: ""})
    const [selectedExps, setSelectedExps] = useState({id: 0, name: ""})
    const [selectedLocation, setSelectedLocation] = useState({id: 0, name: ""})
    const [selectedNumber, setSelectedNumber] = useState(0)
    const addExpList = () => {
        if (selectedInput.id !== 0) {
            let updateDefectList = [...defectLists]
            updateDefectList = updateDefectList.filter(it => it.id !== 0)
            setDefectLists([...updateDefectList, {
                id: selectedInput.id,
                name: selectedInput.name,
                quantity: selectedNumber
            }])
            let _inputLists = [...inputLists]
            if (selectedNumber - selectedInput.quantity === 0) {
                setInputLists(_inputLists.filter(it => it.itemId !== selectedInput.id))
            } else {
                const ind = _inputLists.findIndex(it => it.itemId === selectedInput.id)
                _inputLists[ind].quantity = selectedInput.quantity - selectedNumber
                setInputLists(_inputLists)
            }
            setSelectedInput({id: 0, name: 0, quantity: 0})
            setSelectedDefects({id: 0, name: 0, quantity: 0})
        }
    }
    const deleteExpList = () => {
        if (selectedDefects.id !== 0) {
            let updateDefectList = [...defectLists]
            updateDefectList = updateDefectList.filter(it => it.id !== selectedDefects.id)
            setDefectLists(updateDefectList)
            setInputLists([{
                itemId: selectedDefects.id,
                itemName: selectedDefects.name,
                quantity: selectedDefects.quantity
            }, ...inputLists])
            setSelectedInput({id: 0, name: 0, quantity: 0})
            setSelectedDefects({id: 0, name: 0, quantity: 0})
        }
    }

    return (
        <>
            <div className="container flex flex-column justify-content-between align-content-center w-full h-full">
                <div
                    className="container flex flex-column md:flex-row justify-content-between align-content-center w-full ">
                    <DataTable value={inputLists.map(it => {
                        return {
                            id: it.itemId,
                            name: it.itemName,
                            quantity: it.quantity,
                        }
                    })}
                               selectionMode="single" selection={selectedInput} size="small" scrollable={true}
                               scrollHeight={"230px"} className="pt-2 border-1"
                               onSelectionChange={(e) => {
                                   if (e.value) {
                                       setSelectedNumber(e.value.quantity)
                                       setSelectedInput({
                                           name: e.value.name,
                                           id: e.value.id,
                                           quantity: e.value.quantity,
                                       })
                                   }


                               }} tableStyle={{minWidth: '25rem'}}>
                        <Column field="name" header="Input Component"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                    </DataTable>

                    <DataTable
                        value={outputList.map(it => {
                            return {
                                id: it.itemId,
                                name: it.itemName,
                                quantity: it.quantity,
                                price: it.price,
                            }
                        }) || []}
                        scrollable={true}
                        scrollHeight="230px" size={"small"} className="pt-2 border-1"
                        tableStyle={{minWidth: '25rem'}}>
                        <Column field="name" header="Produce"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                        <Column field="price" header="Price"></Column>
                    </DataTable>
                    <DataTable
                        value={kitUsed.map(it => {
                            return {
                                id: it.id,
                                name: it.name,
                                quantity: it.quantity,
                                price: it.price,
                            }
                        }) || []}
                        scrollable={true}
                        scrollHeight="230px" size={"small"} className="pt-2 border-1"
                        tableStyle={{minWidth: '25rem'}}>
                        <Column field="name" header="Component"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                        <Column field="price" header="Price"></Column>
                    </DataTable>
                </div>
                <div className="container flex flex-row justify-content-start  align-content-center w-full h-25">
                    <Button icon="pi pi-arrow-circle-down " onClick={addExpList} className="m-2"/>
                    <Button icon="pi pi-arrow-circle-up" onClick={deleteExpList} className="m-2"/>
                    <InputNumber value={selectedNumber} onChange={(e) => setSelectedNumber(e.value)}/>
                </div>
                <div className="container flex h-full justify-content-between align-content-center">

                    <DataTable value={defectLists.map(it => {
                        return {
                            id: it.id,
                            name: it.name,
                            quantity: it.quantity,
                        }
                    }) || []}

                               selectionMode="single" selection={selectedDefects} size={"small"}
                               scrollable={true}
                               scrollHeight="220px" className="pt-2 border-1 w-5"
                               onSelectionChange={(e) => (
                                   setSelectedDefects({
                                       name: e.value.name,
                                       id: e.value.id,
                                       quantity: e.value.quantity,
                                   })
                               )} tableStyle={{minWidth: '50rem'}}>
                        <Column field="name" header="Item"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                    </DataTable>
                    <div
                        className="container flex flex-column justify-content-between align-content-center w-5 md:w-4 ">
                        <div
                            className="container flex flex-column md:flex-row justify-content-between align-content-center w-full pb-1 ">
                            <Tag className="md:w-5">Date :</Tag>
                            <Calendar style={{fontSize: '12px'}} id="buttondisplay" dateFormat="dd/mm/yy"
                                      value={selectedDate} onChange={(e) => setSelectedDate(e.value)}
                                      selectionMode={"single"}/>
                        </div>
                        <div
                            className="container flex flex-column md:flex-row justify-content-between align-content-center w-full pb-1 ">
                            <Tag className="md:w-5">Location :</Tag>
                            <Dropdown
                                value={selectedLocation.id}
                                options={locationList} optionValue="id" optionLabel="name"
                                onChange={(e) => {
                                    setSelectedLocation({
                                        id: e.value,
                                        name: locationList.find(it => it.id === e.value).name
                                    });

                                }}
                            />
                        </div>
                        <div
                            className="container flex flex-column md:flex-row justify-content-between align-content-center w-full pb-1 ">
                            <Tag className="md:w-5">Manufacturing Account :</Tag>
                            <Dropdown
                                value={selectedMfxs.id}
                                options={mfxList} optionValue="id" optionLabel="name"
                                onChange={(e) => {
                                    setSelectedMfxs({id: e.value, name: mfxList.find(it => it.id === e.value).name});

                                }}
                            />
                        </div>
                        <div
                            className="container flex flex-column md:flex-row justify-content-between align-content-center w-full pb-1 ">
                            <Tag className="md:w-5">Defect Account :</Tag>
                            <Dropdown
                                value={selectedExps.id}
                                options={expList} optionValue="id" optionLabel="name"
                                onChange={(e) => {
                                    setSelectedExps({id: e.value, name: expList.find(it => it.id === e.value).name});
                                }}
                            />
                        </div>
                        <Button label="Process"
                                disabled={selectedMfxs.id === 0 || selectedExps.id === 0 || selectedLocation.id === 0}
                                onClick={() => {
                                    processData(inputLists, defectLists, selectedMfxs, selectedExps, selectedDate, selectedLocation)

                                }}
                        />
                    </div>


                </div>

            </div>
        </>
    );
}

export default DashBoardPanel;
